export class NotchedMenuSlider extends Phaser.GameObjects.Container {
    constructor(scene, x, y, options = {}) {
        super(scene, x, y);
        
        const {
            options: sliderOptions = [],
            initialValue = 0,
            onChange = () => {},
            label = '',
            minX = 4,
            maxX = -4
        } = options;
        
        this.sliderOptions = sliderOptions;
        this.currentIndex = initialValue;
        this.onChange = onChange;
        this.label = label;
        this.minX = minX;
        this.maxX = maxX;
        this.notchCount = sliderOptions.length - 1;
 
        scene.load.image('sliderChannel', '/sprites/ui/Menu/sliderChannel.png');
        scene.load.image('sliderKnob', '/sprites/ui/Menu/slider.png');
        scene.load.once('complete', () => {
            this.buildSlider(scene);
        });
        scene.load.start();
    }
 
    buildSlider(scene) {
        if (this.label) {
            this.labelText = scene.add.text(0, -20, this.label, { 
                fontSize: '12px',
                color: '#000000'
            });
            this.add(this.labelText);
        }
 
        this.channel = scene.add.sprite(0, 0, 'sliderChannel');
        this.channel.setOrigin(0, 0.5);
 
        this.knob = scene.add.sprite(0, 0, 'sliderKnob');
        this.knob.setOrigin(0.5);
        
        this.valueText = scene.add.text(this.channel.width + 8, -8, this.sliderOptions[this.currentIndex], {
            fontSize: '12px',
            color: '#000000'
        });
        
        this.knob.setInteractive({ draggable: true });
        this.setupDrag();
        this.setValueByIndex(this.currentIndex);
        
        this.add([this.channel, this.knob, this.valueText]);
        scene.add.existing(this);
    }
 
    setupDrag() {
        this.knob.on('drag', (pointer, dragX) => {
            const range = this.channel.width + this.maxX - this.minX;
            const notchWidth = range / this.notchCount;
            const adjustedDragX = dragX - this.minX;
            const nearestNotch = Math.round(adjustedDragX / notchWidth);
            const clampedNotch = Phaser.Math.Clamp(nearestNotch, 0, this.notchCount);
            
            this.setValueByIndex(clampedNotch);
            this.onChange(this.sliderOptions[clampedNotch]);
        });
    }
 
    setValueByIndex(index) {
        const range = this.channel.width + this.maxX - this.minX;
        const notchWidth = range / this.notchCount;
        this.knob.x = this.minX + (index * notchWidth);
        this.currentIndex = index;
        this.valueText.setText(this.sliderOptions[index]);
    }
 
    getValue() {
        return this.sliderOptions[this.currentIndex];
    }
 }